import { make } from 'vuex-pathify';
import { filter, includes, keyBy, keys, remove, shuffle, sortBy, values } from 'lodash';

const signs = keyBy(
    [
        {
            id: 1,
            text: 'Being able to talk to the person in a loving, caring, respectful way (assertively)',
            selected: false
        },
        {
            id: 2,
            text: 'No abuse, including verbal, physical & sexual',
            selected: false
        },
        {
            id: 3,
            text: 'Feeling safe in the relationship',
            selected: false
        },
        {
            id: 4,
            text: 'Feeling comfortable being yourself',
            selected: false
        },
        {
            id: 5,
            text: 'They respect you and you respect them',
            selected: false
        },
        {
            id: 6,
            text: 'If you set ground rules, you both follow them',
            selected: false
        },
        {
            id: 7,
            text: 'They don’t ask you to completely change who you are in order to become who they want you to be',
            selected: false
        },
        {
            id: 8,
            text: 'They accept you for who you are',
            selected: false
        },
        {
            id: 9,
            text: 'You both compromise to make the relationship work',
            selected: false
        }
    ],
    'id'
);
const signsOrder = sortBy(keys(signs), k => parseInt(k));
const signsSelectedQueue = [];
const MAX_SELECTED_SIGNS = 3;

const quiz = keyBy(
    [
        {
            id: 1,
            text: 'Jo doesn’t want to be seen with CJ',
            correctAnswer: 'negative',
            answered: false
        },
        {
            id: 2,
            text: 'They enjoy spending time together watching movies and getting takeout food',
            correctAnswer: 'positive',
            answered: false
        },
        {
            id: 3,
            text: 'Jo is good in the sack!',
            correctAnswer: 'positive',
            answered: false
        },
        {
            id: 4,
            text: 'Jo views CJ as a booty call and it makes CJ feel kinda weird',
            correctAnswer: 'negative',
            answered: false
        },
        {
            id: 5,
            text: 'Jo makes CJ feel bad about themself sometimes',
            correctAnswer: 'negative',
            answered: false
        }
    ],
    'id'
);

const state = {
    title: 'Healthy Relationships',
    complete: false,
    sticker: {
        text: 'Face emoji w/ heart eyes',
        earned: false,
        image: require('@/assets/stickers/stickers_0004_smiley.png')
    },
    bonusSticker: false,
    trophy: false,
    signs,
    signsOrder,
    signsSelectedQueue,
    mySigns: '',
    quiz
};
const getters = {
    ...make.getters(state),
    maxSignsSelected: state => {
        return filter(values(state.signs), { selected: true }).length >= MAX_SELECTED_SIGNS;
    },
    currentQuizItem: state => {
        const remaining = shuffle(filter(values(state.quiz), { answered: false })); // shuffle the remaining unanswered quiz items
        if (remaining && remaining.length) {
            return state.quiz[remaining[0].id]; // pick from the top of the shuffled remaining pile
        }
        return null;
    }
};
const mutations = {
    ...make.mutations(state),
    selectSign(state, sign) {
        if (includes(state.signsSelectedQueue, sign.id)) {
            state.signs[sign.id].selected = false;
            remove(state.signsSelectedQueue, value => {
                return value === sign.id;
            });
        } else {
            state.signsSelectedQueue.push(sign.id);
            if (state.signsSelectedQueue.length > MAX_SELECTED_SIGNS) {
                const id = state.signsSelectedQueue.shift();
                state.signs[id].selected = false;
            }
            state.signs[sign.id].selected = true;
        }
    }
};
const actions = make.actions(state);

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
